import {LooseAutocomplete} from "@/tools";
import {FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ButtonTypeMap, useTheme} from "@mui/material";

type ThemedFontAwesomeIconProps = {
    /**
     * Accepts the theme variants provided by MUI, or also can be a string (color)
     **/
    color?: LooseAutocomplete<ButtonTypeMap["props"]["color"]>;
} & Omit<FontAwesomeIconProps, "color?">;

/**
 * A FontAwesomeIcon that uses the theme's color palette.
 **/
const ThemedFontAwesomeIcon = ({color, ...fontAwesomeIconProps}: ThemedFontAwesomeIconProps) => {
    const theme = useTheme();
    const pickedColor = (color && color != "inherit" ? color : "primary") as keyof typeof theme.palette;
    const finalColor = (theme.palette[pickedColor] as any)?.main || color;

    return <FontAwesomeIcon {...fontAwesomeIconProps} color={finalColor} />;
};

export default ThemedFontAwesomeIcon;
